'use strict';

export default angular
  .module('maestro.services.data.tags', [
    'maestro.services.webcore'
  ])
  .service('TagsService', TagsService)
  .name;

function TagsService(webcore, CacheService, $q) {

  /**
   * Gets popular tags according the filtering and limit params.
   * @param organizationId
   * @param type
   *   User = 1,
   *   Location = 2,
   *   Device = 3,
   *   Files = 4
   * @param category
   *  Default = 0,
   *  Highlights = 1,
   *  Groups = 2
   * @param limit
   * @returns {*}
   */
  this.getPopularTags = CacheService.cachePromiseFunc((organizationId, type, category, limit) => {
    return $q.when(
      webcore.services.tags.getPopularTags(organizationId, type, category, limit)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  });

  /**
   * Deletes specified tags for the specified entities.
   * @param organizationId
   * @param tagType
   * @param entityId
   * @param tagValue
   * @param appId
   * @returns {*}
   */
  this.deleteTags = (organizationId, tagType, entityId, tagValue, appId) => {
    return $q.when(
      webcore.services.tags.deleteTags(organizationId, tagType, entityId, tagValue, appId)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Saves specified tags to the server (api).
   * @param organizationId
   * @param tags
   * @returns {*}
   */
  this.saveTags = (organizationId, tags) => {
    return $q.when(
      webcore.services.tags.applyTags(organizationId, tags)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

}
